import React, {ComponentPropsWithRef, memo, useCallback, useEffect, useRef, useState} from 'react'
import {EmblaCarouselType, EmblaEventType, EmblaOptionsType} from 'embla-carousel'
import useEmblaCarousel from 'embla-carousel-react'
import { MyText} from "../../../common";
import {Col,Flex, Row, Grid} from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import {Link} from "react-router-dom";
import {StyledCarousel, MyCard} from "./styles";
import ClassNames from "embla-carousel-class-names";
import { HeartFilled, HeartOutlined } from "@ant-design/icons";
import {Cookies} from "react-cookie";
import { COOKIE_KEY, fetchSetLikeAction } from '../../../../utils';
import { useEmbeddedNavigate } from '../../../../utils/context/embed';
import { useDispatch } from 'react-redux';
const isMobile = window.innerWidth < 768;



type PropType = {
  slides: any
  options?: EmblaOptionsType
}

type UseDotButtonType = {
  selectedIndex: number
  scrollSnaps: number[]
  onDotButtonClick: (index: number) => void
}


const numberWithinRange = (number: number, min: number, max: number): number =>
  Math.min(Math.max(number, min), max)

const TWEEN_FACTOR_BASE = 0.84


const cookies = new Cookies()

const Component = memo(({item}: any) => {
const navigate = useNavigate();
const embeddedNavigate = useEmbeddedNavigate();
const dispatch = useDispatch();

const { useBreakpoint } = Grid;
const screens = useBreakpoint();
const [likedArticles, setLikedArticles] = useState<{ [key: number]: boolean }>({});
const [likeCounts, setLikeCounts] = useState<{ [key: number]: number }>({});
let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
const isTablet = screens.md && !screens.xl && !screens.xxl;
useEffect(() => {
  if (!item || typeof item !== 'object') return;

  setLikedArticles({ [item.id]: item.is_liked_by_user });
  setLikeCounts({ [item.id]: item.like_count });
}, [item]);


// const toggleLike = (articleId: number) => {
//   setLikedArticles((prev) => ({
//     ...prev,
//     [articleId]: !prev[articleId],
//   }));

//   setLikeCounts((prev) => ({
//     ...prev,
//     [articleId]: prev[articleId] + (likedArticles[articleId] ? -1 : 1),
//   }));
  
//   fetchSetLike(articleId, 'article');
// };

const toggleLike = (articleId: number) => {
  setLikedArticles((prev) => ({
    ...prev,
    [articleId]: !prev[articleId],
  }));
  setLikeCounts((prev) => ({
    ...prev,
    [articleId]: prev[articleId] + (likedArticles[articleId] ? -1 : 1),
  }));
  dispatch(fetchSetLikeAction({ entity_id: articleId, entity_type: 'article' }));
};

return (
    <MyCard
      hoverable
      onClick={() => embeddedNavigate(`/articles/${item.id}`)}
      style={{ height: '420px', display: 'flex',borderRadius: '32px', flexDirection: 'column', marginBottom: '20px' }}
      cover={
        <img src={item.img} alt="" style={{ height: 215, objectFit: 'cover', borderTopLeftRadius: '32px', borderTopRightRadius: '32px' }} />
      }
    >
      <Col span={24} style={{padding: '0'}}>
      <Row gutter={[24, 24]} style={{ flexGrow: 1, height: '100%', }}>
        <Col span={24}>
          <MyText color='#0A033C' size={isTablet ? 14 : 16} weight={600} style={{ textOverflow: 'initial', lineHeight: screens.xs ? '22px' : '18px' }}>
          {item.label.length > 100 ? `${item.label.slice(0, 100)}…` : item.label}
          </MyText>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Flex align='center' gap={8}>

                                {(likedArticles[item.id] ?? item.is_liked_by_user) ? (
                                <HeartFilled
                                  style={{
                                    fontSize: "16px",
                                    color: "rgba(253, 99, 99, 1)",
                                    cursor: "pointer",
                                  }}
                                  // onClick={token ? () => toggleLike(item.id) : undefined}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    if (token) toggleLike(item.id);
                                  }}
                                />
                              ) : (
                                <HeartOutlined
                                  style={{
                                    fontSize: "16px",
                                    color: "rgba(104, 114, 125, 1)",
                                    cursor: "pointer",
                                    height: '24px'
                                  }}
                                  // onClick={token ? () => toggleLike(item.id) : undefined}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    if (token) toggleLike(item.id);
                                  }}
                                />
                              )}
                              <Col>
                              {likeCounts[item.id] > 0 && (
                                <MyText color="rgba(104, 114, 125, 1)" size={16} lineHeight="24px">
                                  {likeCounts[item.id]}
                                </MyText>
                              )}
                              </Col>
            <MyText color='#68727D' size={16} weight={400}>
              {item.likeCount}
            </MyText>
          </Flex>
        </Col>
      </Row>
      </Col>
      
      
    </MyCard>
  );
})

const EmblaCarousel: React.FC<PropType> = (props) => {
  const { slides, options } = props
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [ClassNames()])
  const tweenFactor = useRef(0)
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi)

  const setTweenFactor = useCallback((emblaApi: EmblaCarouselType) => {
    tweenFactor.current = TWEEN_FACTOR_BASE * emblaApi.scrollSnapList().length
  }, [])

  const tweenOpacity = useCallback(
    (emblaApi: EmblaCarouselType, eventName?: EmblaEventType) => {
      const engine = emblaApi.internalEngine()
      const scrollProgress = emblaApi.scrollProgress()
      const slidesInView = emblaApi.slidesInView()
      const isScrollEvent = eventName === 'scroll'

      emblaApi.scrollSnapList().forEach((scrollSnap, snapIndex) => {
        let diffToTarget = scrollSnap - scrollProgress
        const slidesInSnap = engine.slideRegistry[snapIndex]

        slidesInSnap.forEach((slideIndex) => {
          if (isScrollEvent && !slidesInView.includes(slideIndex)) return

          if (engine.options.loop) {
            engine.slideLooper.loopPoints.forEach((loopItem) => {
              const target = loopItem.target()

              if (slideIndex === loopItem.index && target !== 0) {
                const sign = Math.sign(target)

                if (sign === -1) {
                  diffToTarget = scrollSnap - (1 + scrollProgress)
                }
                if (sign === 1) {
                  diffToTarget = scrollSnap + (1 - scrollProgress)
                }
              }
            })
          }

          const tweenValue = 2 - Math.abs(diffToTarget * tweenFactor.current)
          const opacity = numberWithinRange(tweenValue, 0, 1).toString()
          emblaApi.slideNodes()[slideIndex].style.opacity = opacity
        })
      })
    },
    []
  )

  useEffect(() => {
    if (!emblaApi) return

    setTweenFactor(emblaApi)
    tweenOpacity(emblaApi)
    emblaApi
      .on('reInit', setTweenFactor)
      .on('reInit', tweenOpacity)
      .on('scroll', tweenOpacity)
      .on('slideFocus', tweenOpacity)
  }, [emblaApi, tweenOpacity])


  return (
    <StyledCarousel isTablet={isTablet} isXs={screens.xs}>
      <section className="embla">
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container" >
            {slides.map((item: any, index: number) => (
              <div className="embla__slide embla__class-names" key={index} >
                <Component item={item}/>
              </div>
            ))}
          </div>
        </div>

        <div className="embla__controls">
          <div className="embla__dots">
            {scrollSnaps.map((_, index) => (
              <DotButton
                key={index}
                onClick={() => onDotButtonClick(index)}
                className={'embla__dot'.concat(
                  index === selectedIndex ? ' embla__dot--selected' : ''
                )}
              />
            ))}
          </div>
        </div>
      </section>
    </StyledCarousel>

  )
}


export const useDotButton = (
  emblaApi: EmblaCarouselType | undefined
): UseDotButtonType => {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([])

  const onDotButtonClick = useCallback(
    (index: number) => {
      if (!emblaApi) return
      emblaApi.scrollTo(index)
    },
    [emblaApi]
  )

  const onInit = useCallback((emblaApi: EmblaCarouselType) => {
    setScrollSnaps(emblaApi.scrollSnapList())
  }, [])

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setSelectedIndex(emblaApi.selectedScrollSnap())
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    onInit(emblaApi)
    onSelect(emblaApi)
    emblaApi.on('reInit', onInit).on('reInit', onSelect).on('select', onSelect)
  }, [emblaApi, onInit, onSelect])

  return {
    selectedIndex,
    scrollSnaps,
    onDotButtonClick
  }
}

type PropTypeDot = ComponentPropsWithRef<'button'>

const DotButton: React.FC<PropTypeDot> = (props) => {
  const { children, ...restProps } = props

  return (
    <button type="button" {...restProps}>
      {children}
    </button>
  )
}


export default EmblaCarousel